// Stacked-chart palette for billing rows.
// Cycled by row index — extras wrap around.
export const ROW_COLORS = [
  '#2B203E', // navy
  '#5C7A3E', // sage
  '#7C8A4F', // olive
  '#B8862A', // amber
  '#8B6F47', // brown
  '#6B7B9C', // blue-grey
  '#A89A7C', // taupe
];

export function rowColor(index) {
  return ROW_COLORS[((index % ROW_COLORS.length) + ROW_COLORS.length) % ROW_COLORS.length];
}
